
  export default {
    name: 'DefaultSystemBar',

    data: () => ({
      model: true,
    }),
  };
